export const ADD_POST = "Post/ADD_POST";
export const ADD_NFT = "Post/ADD_NFT";
export const ADD_POST_ERROR = "Post/ADD_POST_ERROR";
export const GET_POSTS = "Post/GET_POSTS";
export const SET_POSTS_DATA = "Post/SET_POSTS_DATA";
export const DELETE_POST = "Post/DELETE_POST";
export const ADD_COMMENT = "Post/ADD_COMMENT";
export const DELETE_COMMENT = "Post/DELETE_COMMENT";
